export const availableFeatures = [
  'Horsepower and Torque',
  'Transmission Type',
  'Drivetrain Type',
  'Fuel Economy',
  'Charging Battery Speed',
  'Battery Warranty',
  'Body Style',
  'Engine Type',
  'Seating Capacity',
  'Estimated Battery Range',
  'Leg Room',
  'Head Room',
  'BLIS (Blind Spot Information System)',
  'Lane Keeping Alert Lane Keeping Assist',
  'Heated seat',
]
